import Nav from './Nav.js'
import Navp from './Navp.js'
import { useState } from 'react'

export default function Header() {
    let [Click, setClick] = useState(false)
    let clickHandler = function () {
        setClick(!Click)
    }

    return (
        <>
        <div class='Header-P'>
                <img src={require("../../Icon.png")} alt="icon" class="HeaderIcon"/>
                <span onClick={clickHandler} class="stash--burger-classic"></span>
        </div>
        <Navp Click={Click} Close={clickHandler}/>
        <div class="StandardHeader">
            <img src={require("../../Icon.png")} alt="icon" class="HeaderIcon"/>
            <Nav id="nav-p"/>
        </div>
        </>
    )
}